import { useState, useCallback } from 'react';
import { EventRenderedArgs } from '@syncfusion/ej2-react-schedule';
import {
  colors,
  HOLIDAY_EVENT_COLOR,
} from 'Pages/LearningSchedule/constants/constants';

export const useEventColors = () => {
  const [eventsColors, setEventsColors] = useState<{ [key: string]: string }>(
    {}
  );
  const [colorIndex, setColorIndex] = useState<number>(0);

  const applyCategoryColor = useCallback(
    (args: EventRenderedArgs) => {
      if (!args.element) return;

      const { Id, holidayCountry } = args.data;
      if (holidayCountry) {
        args.element.style.backgroundColor = HOLIDAY_EVENT_COLOR;
        return;
      }

      if (eventsColors[Id]) {
        args.element.style.backgroundColor = eventsColors[Id];
        return;
      }

      const categoryColor = colors[colorIndex];
      args.element.style.backgroundColor = categoryColor;

      setEventsColors((prev) => {
        return {
          ...prev,
          [args.data.Id]: categoryColor,
        };
      });
      setColorIndex((prev) => (prev + 1) % colors.length);
    },
    [eventsColors, colorIndex]
  );

  return {
    eventsColors,
    colorIndex,
    applyCategoryColor,
  };
};
